
import { NavigationKey } from '../../../types';

export const navigation: Record<NavigationKey, string> = {
  welcome: 'Bienvenue',
  dashboard: 'Tableau de Bord',
  myVideos: 'Mes Vidéos',
  analytics: 'Analytiques',
  settings: 'Paramètres',
  profile: 'Profil',
  logout: 'Déconnexion',
  feed: 'Fil d\'Actualité',
  latestVideos: 'Vidéos Récentes',
  finance: 'Finance',
  support: 'Support',
  tracking: 'Suivi',
  integrations: 'Intégrations',
  security: 'Sécurité',
  partners: 'Partenaires',
  help: 'Aide',
  início: 'Accueil',
  novoVídeo: 'Nouvelle Vidéo',
  personalização: 'Personnalisation',
  funnelVideo: 'Entonnoir Vidéo',
  vsleads: 'VSLeads',
  métricas: 'Métriques',
  testeAB: 'Test A/B',
  hookTrack: 'Teste de hook',
  rastreamento: 'Suivi',
  integrações: 'Intégrations',
  segurança: 'Sécurité',
  proteçãoDomínios: 'Protection de Domaine',
  cloakerVSL: 'Cloaker VSL',
  parceiros: 'Partenaires',
  membros: 'Membres',
  botaoAcao: 'Bouton d\'Action',
  ajuda: 'Aide',
  masterClass: 'Master Class',
  compartilhar: 'Partager',
  capturaLeads: 'Capture de Leads',
  dominios: 'Domaines',
  chat: 'Chat',
  centralAjuda: "Centre d'Aide",
  cloaker: 'Cloaker',
  personalizar: 'Personnaliser',
};
